export const fragmentUserForProfile = /* GraphQL */ `
 fragment fragmentUserForProfile on User {
    id
    email
    name
    avatar
    is_blocked
    profile
    role
    phone
    timezone
 }`;
export const fragmentUserForConstructorSettings = /* GraphQL */ `
 fragment fragmentUserForConstructorSettings on User {
    id
    email
    is_blocked
    role
 }`;
export const fragmentUserForQuizWidgetSiteCode = /* GraphQL */ `
 fragment fragmentUserForQuizWidgetSiteCode on User {
   id
   email
   name
   is_blocked
   profile
   role
   phone
   tarif {
      id
      name
      price
      maxLeadsCount
      maxQuizzesCount
  },
 }`;
export const fragmentUserForUserStore = `
  fragment fragmentUserForUserStore on User {
    id
    email
    name
    ip_country
    role
    avatar
    profile
    oauth {
       provider
       scopes
    }
    tarifs {
       id
       name
       lookup_key
       price
       usedLeads
       maxLeadsCount
       maxQuizzesCount
       is_active
       start_at
       created_at
       end_at
    }
    period_starts_at
    created_at
    quizCounter
    leadCounter
    is_blocked
    # learning_center
    bonuses {
       id
       active
       start
       end
       leads_count
       used
       coupon
    }
 }`;
export const fragmentUserForUsersView = `
  fragment fragmentUserForUsersView on User {
    id
    email
    name
    role
    avatar
    profile
    tarif {
       id
       name
       price
       usedLeads
       maxLeadsCount
       maxQuizzesCount
    }
    payments { 
       id
       payment
       amount
       created_at
    }
    created_at
    quizCounter
    leadCounter
    is_blocked
    # learning_center
    bonuses {
       start
       end
       leads_count
       active
    }
 }`;
export const fragmentUserForHeader = `
  fragment fragmentUserForHeader on User {
    id
    email
    name
    role
    profile
    avatar
    is_blocked
    interface_lang
    tarifs {
       id
       name
       price
       usedLeads
       maxLeadsCount
       maxQuizzesCount
       created_at
       is_active
       start_at
       end_at
    }
    period_starts_at
    payments { 
       id
       payment_system
       payment
       amount
       created_at
       data
       docs
    }
    created_at
    quizCounter
    leadCounter
    is_blocked
    bonuses {
       id
       active
       start
       end
       leads_count
       used
       coupon
    }
 }`;
export const fragmentUserForTeamValidation = `
  fragment fragmentUserForTeamValidation on User {
    __typename
  }
`;